var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside-menu-button is-clickable",class:{ 'is-active': _vm.isActive },on:{"click":_vm.toggleActiveAsideMenu}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }